'use client';

import { type ReactNode } from 'react';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';

type AnchorAttributes = React.AnchorHTMLAttributes<HTMLAnchorElement>;

interface AnchorProps {
    'aria-current'?: AnchorAttributes['aria-current'];
    'aria-label'?: AnchorAttributes['aria-label'];
    children?: ReactNode;
    className?: AnchorAttributes['className'];
    id?: AnchorAttributes['id'];
    onClick?: AnchorAttributes['onClick'];
    rel?: AnchorAttributes['rel'];
    style?: AnchorAttributes['style'];
    target?: AnchorAttributes['target'];
}

interface LinkProps {
    href: NextLinkProps['href'];
    prefetch?: NextLinkProps['prefetch'];
    scroll?: NextLinkProps['scroll'];
    shallow?: NextLinkProps['shallow'];
}

interface CustomProps {
    hardRefresh?: boolean;
    isSponsored?: boolean;
}

export interface Props extends AnchorProps, LinkProps, CustomProps {}

export const Link = ({ hardRefresh, href, isSponsored, prefetch, shallow, scroll, ...shared }: Props) => {
    if (isSponsored) {
        href = href.toString().replace(/\[/g, '%5B').replace(/\]/g, '%5D');
        shared.rel = 'sponsored nofollow';
        shared.target = '_blank';
    }

    if (hardRefresh) {
        if (shared.target === '_blank' && !shared.rel) {
            shared.rel = 'noopener noreferrer';
        }
        return <a href={href.toString()} {...shared} />;
    }

    return (
        <NextLink href={href} prefetch={prefetch ?? false} shallow={shallow} scroll={scroll} {...shared} />
    );
};
